import { Client, ViamClient, RobotClient, MachineConnectionEvent, ViamClientOptions, createViamClient, AccessToken, VisionClient, createRobotClient, SensorClient, CameraClient, BoardClient, DialConf } from '@viamrobotics/sdk';
import fetch from 'node-fetch';
import { Struct } from '@viamrobotics/sdk';
import { machine } from 'os';
import { error } from 'console';

// globals
const F_CLIENT_ID = process.env.F_CLIENT_ID
const NODE_ENV = process.env.NODE_ENV || "development"
const LOGIN_CALLBACK = NODE_ENV === "development" ? "http://localhost:8000/callback" : "https://quickqueue-admin.com/callback"
const reconnectAbortSignal = { abort: false };
let configChanged = false;
let currentEdit = false;

const concessionOptions = [
'Barbecue',
  'Beer',
  'Burgers',
  'Chicken',
  'Cocktails',
  'Coffee',
  'Dessert',
  'Fries',
  'Hot Dogs',
  'Ice Cream',
  'Mexican',
  'Nachos',
  'Pizza',
  'Pretzel',
  'Salad',
  'Sandwiches',
  'Seltzers',
  'Snacks',
  'Sushi',
  'Wine',
  'Gluten Free',
  'Kosher',
  'Vegan',
  'Vegetarian'
];


const machineConnect = async (address) => {
  reconnectAbortSignal.abort = false;

  let toReturn = {
    machine: RobotClient || undefined,
    error: undefined
  };

  
  try {
    toReturn.machine = await createRobotClient({
      host: address || '',
      credentials: { type: 'access-token',
        payload: LOGIN_TOKEN},
      signalingAddress: 'https://app.viam.com:443',
      reconnectAbortSignal,
      reconnectMaxAttempts: 1,
      reconnectMaxWait: 5
    });
  } catch (error) {
    console.error("Error connecting to machine: " + error)
    toReturn.error = error;
    return toReturn
  }

  return toReturn
};

async function appConnect(): Promise<ViamClient> {
  const opts: ViamClientOptions = {
    credentials: { type: 'access-token',
      payload: LOGIN_TOKEN},
  };

  let client;
  try {
    client = await createViamClient(opts);
  } catch {
    console.error("Error connecting to Viam")
  }

  return client;
}

async function main() {
  let bathroom_container = document.querySelector("#bathroom_container");
  let concession_container = document.querySelector("#concession_container");
  let bathroom_header = document.querySelector("#bathroom_header");
  let concession_header = document.querySelector("#concession_header");

  document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".pure-menu-item");

    menuItems.forEach(item => {
        item.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior

            // Remove 'pure-menu-selected' from all items
            menuItems.forEach(i => i.classList.remove("pure-menu-selected"));

            // Add 'pure-menu-selected' to the clicked item
            this.classList.add("pure-menu-selected");

            const clicked = this.textContent.trim();
            if (clicked == "Concessions") {
              bathroom_container.style.display = "none";
              bathroom_header.style.display = "none";
              concession_container.style.display = "block";
              concession_header.style.display = "block";

            } else {
              concession_container.style.display = "none";
              concession_header.style.display = "none";
              bathroom_container.style.display = "block";
              bathroom_header.style.display = "block";
            }
        });
    });
  });

  // reset path without redirect
  const url = window.location.origin + window.location.pathname;
  window.history.replaceState(null, '', url);
  window.history.pushState({}, '', '/'); 

  while (true) {
    let app: ViamClient | undefined = undefined;
    let app_connected = false;
    
    while (! app_connected) {
      try {
        app = await appConnect();
        console.log('app connected!');
        app_connected = true;
      } catch (error) {
        console.log(error);
      }
      await new Promise(r => setTimeout(r, 500));
    }

    try {
      const published_data = await getPublishedData()

      let all_parts = []
      let machine_addresses = []

      const machines = await app?.appClient.listRobots(process.env.LOCATION_ID)
      for (const m of machines) {
        let parts = await app?.appClient.getRobotParts(m.id)
        for (const p in parts) {
          if ( ! /jetson-/.test(parts[p].fqdn)) {
            all_parts.push({ "id" : parts[p].id })
            machine_addresses.push(parts[p].fqdn)
          }
        }
      }
      console.log(all_parts)
      console.log(machine_addresses)

      const components_by_name = await getComponentsByName(app, all_parts)

      const lines = {};

      const machine_routines = machine_addresses.map(address => 
        getMachineData(address, components_by_name, lines)
      );
    
      let bathroomEntries = [];
      const concessionEntries = [];

      const results = await Promise.all(machine_routines);
      results.forEach(res => {
        const entries = Object.entries(res);
        for (const [entry, data] of entries) {
          if (data.queue_readings["concession_options"]) {
            concessionEntries.push([entry, data])
          } else {
            bathroomEntries.push([entry, data])
          }
        }
      });

      // Sort the array based on the location_name
      bathroomEntries.sort((a, b) => {
        const locationA = a[1].queue_readings.location_name.toLowerCase();
        const locationB = b[1].queue_readings.location_name.toLowerCase();
        return locationA.localeCompare(locationB);
      });
      concessionEntries.sort((a, b) => {
        const locationA = a[1].queue_readings.location_name.toLowerCase();
        const locationB = b[1].queue_readings.location_name.toLowerCase();
        return locationA.localeCompare(locationB);
      });

      // if we modified or are modifying data while we were pulling new data, skip this pass of displaying it
      if (configChanged || currentEdit) {
        configChanged = false;
        continue;
      }

      populateTable("bathroom", bathroomEntries, app, components_by_name, all_parts);
      populateTable("concession", concessionEntries, app, components_by_name, all_parts);
    } catch (error) {
      console.log(error);
    }
    await new Promise(r => setTimeout(r, 5000));
  }
}

function populateTable(type, entries, app, components_by_name, all_parts) {
  let table = type === "bathroom" ? document.querySelector("#bathroom_table") : document.querySelector("#concession_table");

  let loading_row = document.getElementById(`${type}_loading_row`)
  loading_row.style.display = 'none';

  for (const [entry, data] of entries) {
    let row = document.getElementById(data.name)
    if (!row) {
      row = table.insertRow();
      row.id = data.name
    }

    // clear existing cells
    while (row.firstChild) {
      row.removeChild(row.firstChild);
    }

    let cell = row.insertCell();
    let name_span = document.createElement("span");
    name_span.id = "location_name_" + data.name;
    name_span.textContent = components_by_name[data.name].config.attributes.extra_fields.location_name;
    
    // the open/closed location slider      
    const open_container = createSlider(app, components_by_name, all_parts, data.name, 'location_open', 'open', 'closed', true, false)
    cell.appendChild(name_span);
    
    if (type === "concession") {
      const input = document.createElement("input"); // Create <input> element
      input.type = "text"; // Set type
      input.id = "name_edit_box_" + data.name;
      input.value = components_by_name[data.name].config.attributes.extra_fields.location_name;
      Object.assign(input.style, {"display": "none"});
      cell.appendChild(input);

      const edit_icon = document.createElement("i");
      edit_icon.id = "name_edit_" + data.name;
      edit_icon.classList.add("si-edit");
      Object.assign(edit_icon.style, {"padding-left": "3px", "font-size": "22px", "color": "#0000aa", "cursor": "pointer" });

      const save_icon = document.createElement("i");
      save_icon.id = "name_edit_save_" + data.name;
      save_icon.classList.add("si-check-square");
      Object.assign(save_icon.style, {"display": "none", "padding-left": "3px", "font-size": "22px", "color": "#0000aa", "cursor": "pointer" });

      edit_icon.addEventListener("click", function () {
        currentEdit = true;
        name_span.style.display = "none";
        input.style.display = "inline";
        save_icon.style.display = "inline";
        edit_icon.style.display = "none";
      });

      save_icon.addEventListener("click", async function () {
        input.style.display = "none";
        save_icon.style.display = "none";
        edit_icon.style.display = "inline";
        name_span.style.display = "inline";
        await updateConfig(app, components_by_name, all_parts, data.name, "attributes.extra_fields.location_name", input.value, false);
        name_span.textContent = input.value;
        currentEdit = false;
      });


      cell.appendChild(edit_icon);
      cell.appendChild(save_icon);
    }

    cell.appendChild(open_container);

    cell = row.insertCell();
    let type_container;
    if (type === "bathroom") {
      type_container = createSlider(app, components_by_name, all_parts, data.name, 'gender', 'M', 'W', 'M', 'W')
    } else {
      type_container = createCheckboxGroup(app, components_by_name, all_parts, data.name, 'concession_options', concessionOptions)
    }
    cell.appendChild(type_container);

    cell = row.insertCell();
    let text = document.createTextNode(data.queue_readings.count_in_view);
    cell.appendChild(text);

    cell = row.insertCell();
    const status = data.queue_readings.estimated_wait_time_min
    text = document.createTextNode(status === "green" ? "Not busy" : status === "yellow" ? "Less busy" : "More busy");
    cell.appendChild(text);

    cell = row.insertCell();
    for (const image of data.full_images) {
      const img = document.createElement('img');
      img.src = image;
      img.classList.add('zoomable-image');
      img.addEventListener('click', () => zoomImage(image, type));
      img.addEventListener('touchend', (e) => {
          e.preventDefault();
          zoomImage(image, type);
      });
      cell.appendChild(img);
    }

    cell = row.insertCell();
    for (const image of data.cropped_images) {
      const img = document.createElement('img');
      img.src = image;
      img.classList.add('zoomable-image');
      img.addEventListener('click', () => zoomImage(image, type));
      img.addEventListener('touchend', (e) => {
          e.preventDefault();
          zoomImage(image, type);
      });
      cell.appendChild(img);
    }

  }
}


async function login() {
  console.log("LOGIN")
  window.location.replace('https://auth.viam.com/oauth2/authorize?client_id='+F_CLIENT_ID+'&response_type=code&redirect_uri=' + encodeURI(LOGIN_CALLBACK))
}

async function updateConfig(app:ViamClient, components_by_name, all_parts, component, path, value, updateLocationName) {
  configChanged = true;
  console.log(component + " " + path + " " + value)
  let updated_component_config = setNestedValue(components_by_name[component].config, path, value)
  if (updateLocationName) {
    if (value === 'M') {
      updated_component_config["attributes"]["extra_fields"]["location_name"] = updated_component_config["attributes"]["extra_fields"]["location_name"].replace('Women', 'Men');
    }
    else {
      updated_component_config["attributes"]["extra_fields"]["location_name"] = updated_component_config["attributes"]["extra_fields"]["location_name"].replace('Men', 'Women');
    }
  }
  console.log(updated_component_config)
  for (const p of all_parts) {
    if (p.id === components_by_name[component].part_id) {
      for (let c = 0; c < p.config.components.length; c++) {
        if (p.config.components[c].name === component) {
          p.config.components[c] = updated_component_config
          console.log(p.config)
          app.appClient.updateRobotPart(p.id, components_by_name[component].part_name, Struct.fromJson(p.config))
        }
      }
    }
  }
}

function getSelectedCheckboxes(name) {
  const checkboxes = document.querySelectorAll(`input[name="${name}"]:checked`);
  return Array.from(checkboxes).map(checkbox => checkbox.value);
}

function createCheckboxGroup(app, components_by_name, all_parts, name, field, all_options) {
  const container = document.createElement('div');
  container.className = "checkbox-container"

  const current_checked = components_by_name[name].config.attributes.extra_fields[field];

  for (const option in all_options) {
    const label = document.createElement("label_" + name);
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.name = 'checkbox_' + name;
    checkbox.value = all_options[option];
    checkbox.checked = current_checked.includes(all_options[option]) ? true : false;
    checkbox.addEventListener('change', async function() {
      await updateConfig(app, components_by_name, all_parts, name, "attributes.extra_fields." + field, getSelectedCheckboxes(checkbox.name), false);
    });
    label.appendChild(checkbox);
    label.appendChild(document.createTextNode(" " + all_options[option]));

    container.appendChild(label);
    container.appendChild(document.createElement("br"));
  }

  return container
}

function createSlider(app, components_by_name, all_parts, name, field, checked_label, unchecked_label, checked_value, unchecked_value) {
  const container = document.createElement('div');
  container.className = "toggle-container"
  const label_wrap = document.createElement("label")
  label_wrap.className = "toggle"

  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.id = 'checkbox_' + name;
  checkbox.checked = components_by_name[name].config.attributes.extra_fields[field] === checked_value ? true : false;
  checkbox.addEventListener('change', async function() {
    let updateLocationName = false;
    if (field === "gender") {
      updateLocationName = true;
    }
    await updateConfig(app, components_by_name, all_parts, name, "attributes.extra_fields." + field, this.checked ? checked_value : unchecked_value, updateLocationName);
    let label = document.getElementById(field + "_label_" + name)
    label.firstChild.nodeValue = (this.checked ? checked_label : unchecked_label)
  });

  const slider = document.createElement('span');
  slider.className = field === "gender" ? "slider slider-pink" : "slider"

  label_wrap.appendChild(checkbox);
  label_wrap.appendChild(slider);

  // Create a label for the checkbox
  const label = document.createElement('span');
  label.className = "toggle-label"
  let label_text = document.createTextNode(components_by_name[name].config.attributes.extra_fields[field] === checked_value ? checked_label : unchecked_label)
  label.id = field + "_label_" + name
  label.appendChild(label_text)

  container.appendChild(label_wrap)
  container.appendChild(label)

  return container
}

function setNestedValue(obj, path, value) {
  if (typeof path !== "string") {
    throw new Error("Path must be a string in dot notation.");
  }

  const keys = path.split(".");
  let current = obj;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    // If it's the last key, set the value
    if (i === keys.length - 1) {
      current[key] = value;
    } else {
      // Ensure the next level is an object if it doesn't exist
      if (!current[key] || typeof current[key] !== "object") {
        current[key] = {};
      }
      current = current[key];
    }
  }

  return obj;
}

async function getMachineData(address, components_by_name, bathroom_lines) {
  // Connect to client
  let machine;
  let connected = false;
  let tries = 0;
  while (! connected) {
    machine = await machineConnect(address);
    if (machine.error) {
      await new Promise(r => setTimeout(r, 500));
      tries++;
      if (tries > 1) {
        return bathroom_lines;
      }
    } else {
      console.log('connected!');
      connected = true;
    }
  }

  const resource_names = await machine.machine?.resourceNames()
  const resource_routines = [];

  for (const m of resource_names) {
    if (m.name in components_by_name) {
      resource_routines.push(getData(machine.machine, m.name, components_by_name));
    }
  }

  const results = await Promise.all(resource_routines);
  for (const res of results) {
    bathroom_lines[res.name] = res;
  }
  
  await machine.machine?.disconnect();
  return bathroom_lines;
}

async function getData(machine, name, components_by_name) {
  const queue_sensor = new SensorClient(machine, name);
  const queue_readings = await queue_sensor.getReadings();
  console.log(`${name} get_readings return value: ${JSON.stringify(queue_readings)}`);

  // full camera images
  const full_images = [];
  let full_image_count = 0;
  console.log(name)
  const camera_names = Object.keys(components_by_name[name].config.attributes.valid_regions);

  for (const camera_name of camera_names) {
    console.log(camera_name);
    const camera = new CameraClient(machine, camera_name);
    const full_image = await camera.getImage();
    console.log("got image")    
    full_images.push(uint8ArrayToBase64Image(full_image));
    full_image_count++;
  }

  // cropped images
  const cropped_images = [];
  for (let count = 0; count < full_image_count; count++) {
    const append = count > 0 ? `-${count + 1}` : '';
    const crop_camera_name = `cam-${name.replace('queue-', '')}-crop${append}`;
    console.log(crop_camera_name);
    try {
      const camera = new CameraClient(machine, crop_camera_name);
      const crop_image = await camera.getImage();
      cropped_images.push(uint8ArrayToBase64Image(crop_image));
    }
    catch (error) {
      console.log("Crop camera not found: " + crop_camera_name)
    }
  }

  return {
    machine,
    name,
    queue_readings,
    full_images,
    cropped_images
  };
}

function uint8ArrayToBase64Image(uint8Array, mimeType = 'image/jpeg') {
  // Convert Uint8Array to binary string
  const binaryString = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
  
  // Convert binary string to base64
  const base64String = btoa(binaryString);
  
  // Create the data URL
  return `data:${mimeType};base64,${base64String}`;
}

async function getComponentsByName(app, all_parts) {
  let components_by_name = {}
  let part_index = 0
  for (const part of all_parts) {
    const response = await app?.appClient.getRobotPart(part.id)
    const config = JSON.parse(response?.configJson)
    all_parts[part_index].config = config
    part_index++
    console.log(response)
    // make to copy config by value so we can update it
    if ("components" in config) {
      config.components.forEach((x, i) => { if (/viam:queue-estimator/.test(x.model)) { components_by_name[x.name] = { "config": structuredClone(x), "part_id": part.id, "part_name": response.part.name } } });
    }
  }
  console.log(components_by_name)

  return components_by_name
}
async function getPublishedData() 
{
    try {
      const response = await fetch("https://storage.googleapis.com/queue_tracker_data/latest_sensor_readings.json", null);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const jsonString = await response.text();
      const prodData = JSON.parse(jsonString);
      
      console.log("Fetched data:", prodData);
      return prodData;
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
      throw error;
    }
}

const zoomOverlay = document.getElementById('zoomOverlay');
const zoomedImage = document.getElementById('zoomedImage');
const zoomOverlayConcessions = document.getElementById('zoomOverlayConcessions');
const zoomedImageConcessions = document.getElementById('zoomedImageConcessions');

// Function to zoom image
function zoomImage(src, type) {
  const overlay = type === "bathroom" ? zoomOverlay : zoomOverlayConcessions;
  const image = type === "bathroom" ? zoomedImage : zoomedImageConcessions;
  overlay.style.display = 'block';
  image.src = src;
}

// Function to dismiss zoom
function dismissZoom() {
  zoomOverlay.style.display = 'none';
}
function dismissZoomConcessions() {
  zoomOverlayConcessions.style.display = 'none';
}

// Event listener for dismissing zoom
zoomOverlay.addEventListener('click', dismissZoom);
zoomOverlay.addEventListener('touchend', (e) => {
  e.preventDefault();
  dismissZoom();
});
zoomOverlayConcessions.addEventListener('click', dismissZoomConcessions);
zoomOverlayConcessions.addEventListener('touchend', (e) => {
  e.preventDefault();
  dismissZoom();
});

// Prevent dismissal when clicking/tapping the zoomed image itself
zoomedImage.addEventListener('click', (e) => e.stopPropagation());
zoomedImage.addEventListener('touchend', (e) => {
  e.preventDefault();
  e.stopPropagation();
});
zoomedImageConcessions.addEventListener('click', (e) => e.stopPropagation());
zoomedImageConcessions.addEventListener('touchend', (e) => {
  e.preventDefault();
  e.stopPropagation();
});

function getFragmentParams() {
  const hash = window.location.hash.substring(1); // Remove the '#'
  const params = {};

  hash.split('&').forEach(param => {
    const [key, value] = param.split('=');
    params[key] = decodeURIComponent(value);
  });

  return params;
}

if (LOGIN_TOKEN=="") {
    login();
}
else {
  main();
}